export enum TipoRelatorio {
    PDF = 'PDF',
    XLSX = 'EXCEL'
  }